import {retrieveRequestFactory, RETRIEVE_SUCCESS, RETRIEVE_ERROR, RETRIEVE_REQUEST} from 'store/generic/actions';

export const COLLECTION_NAME = 'LANG';

export const RETRIEVE_LANGS_REQUEST = RETRIEVE_REQUEST + '_' + COLLECTION_NAME;
export const RETRIEVE_LANGS_ERROR = RETRIEVE_ERROR + '_' + COLLECTION_NAME;
export const RETRIEVE_LANGS_SUCCESS = RETRIEVE_SUCCESS + '_' + COLLECTION_NAME;

export const setLanguages = (payload) => ({
    type: RETRIEVE_LANGS_SUCCESS,
    languages: payload.languages,
});

export const retrieveLangs = retrieveRequestFactory('languages', COLLECTION_NAME, true, setLanguages);



// WEBPACK FOOTER //
// ./src/store/languages/actions.js